import { Component, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { RestService } from '../services/rest/rest.service';
import { LoginResponse, GenericResponse } from '../interfaces/apiresponses';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {TextDirectionController} from '../shared/TextDirectionController'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})


export class LoginComponent {
  @ViewChild("username") usernameField: ElementRef | undefined
  public directionController = new TextDirectionController();
  
  pageDirection = 'ltr'
  bShowLoginScreen = true
  bShowForgetPassword = false
  bLoading = false
  bAlert = false
  customStylesValidated = false
  bShowOTPScreen = false
  otpString = new FormControl()
  appVersion = environment.version
  bShowSecondAlertButton = false
  alertHeaderText = ""
  alertBodyText = ""
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any
  langValue:any;
  loginForm = new FormGroup(
    {
      appLanguage: new FormControl(),
      username: new FormControl(),
      password: new FormControl()
    }
  )

  resetPasswordForm = new FormGroup(
    {
      username: new FormControl()
    }
  )

  otpForm = new FormGroup(
    {
      otpString: this.otpString
    }
  )

  constructor(
    private service: RestService, 
    private auth: AuthService, 
    private route: Router, 
    public translate: TranslateService,
    private renderer: Renderer2) {}

  ngOnInit(): void {
    if (this.auth.isLoggedIn())
    {
      // Already authenticated - so login
      //this.route.navigate(['dashboard'])
    }
    if(this.loginForm.value.appLanguage === null && sessionStorage.getItem('lang') === null)
      this.langValue = 'en'
    else if(sessionStorage.getItem('lang'))
      this.langValue =   sessionStorage.getItem('lang')
    else
      this.langValue =   sessionStorage.getItem('lang')
    
    
  }

  showScreen(loginScreen: boolean, forgotPasswordScreen: boolean, validateOTPScreen: boolean)
  {
    this.bShowForgetPassword = forgotPasswordScreen
    this.bShowLoginScreen = loginScreen
    this.bShowOTPScreen = validateOTPScreen
  }

  login()
  {
    localStorage.clear()
    
    this.customStylesValidated = true

    if (this.loginForm.valid)
    {
      this.bLoading = true

      let loginRequest = {
        email: this.loginForm.value.username,
        password: this.loginForm.value.password,}

      this.service.login(loginRequest).subscribe({
        next: (v: LoginResponse) => {
       if (!v.success) {
          this.bLoading = false;

          this.showAlertBox('Sorry', 'Invalid username or password');
          return;
          }

          localStorage.setItem('token', v.token)
          //console.log('Token set: ' + localStorage.getItem('token'))
          localStorage.setItem('userType', v.userType.toString())
          localStorage.setItem('name', v.name)
          localStorage.setItem('email', this.loginForm.value.username)
          localStorage.setItem('temppassword', v.isTemporaryPassword?'true':'false')

          if (v.token != localStorage.getItem('token'))
          {
            console.log("*** THE TOKEN DIDNT SAVE *** ")
          }

        if (v.isTemporaryPassword)
            this.route.navigate(['changepassword']);
            else
            this.route.navigate(['home']);
        },
        error: (e) => {
          this.bLoading = false
          this.showAlertBox('Sorry', 'Invalid email ID or password. Please try again!')
        },
        complete: () => {
          this.bLoading = false

          // if (localStorage.getItem('temppassword') === 'true')
          //   this.route.navigate(['changepassword'])
          // else
          //   this.route.navigate(['home'])
        }
      })
    }
  }

  resetPassword()
  {
    this.customStylesValidated = true

    if (this.resetPasswordForm.valid)
    {
      this.bLoading = true

      let otpRequest = {
        email: this.resetPasswordForm.value.username
      }

      this.service.requestOTP(otpRequest).subscribe({
        next: (v: GenericResponse) => {          
          if(!v.success)  {
            this.bLoading = false
            this.showAlertBox('Sorry', 'Unable to process your request. Please try again!')
          }
          else  {
            this.bLoading = false
            this.bShowOTPScreen = true
          }
        },
        error: (e) => {
          this.bLoading = false
          this.showAlertBox('Sorry', 'Unable to process your request. Please try again!')
        },
        complete: () => {          
          this.bShowForgetPassword = false
          this.bLoading = false
          this.bShowOTPScreen = true
        }
      })
      
    }
  }

  validateOTP()
  {
    this.customStylesValidated = true

    if (this.otpForm.valid)
    {
      console.log(this.otpForm.value.otpString)

      if (this.otpForm.value.otpString == undefined || this.otpForm.value.otpString.length === 0)
      {
        return
      }

      let validateRequest = {
        email: this.resetPasswordForm.value.username,
        OTP: this.otpForm.value.otpString
      }

      this.bLoading = true

      this.service.validateOTP(validateRequest).subscribe({
        next: (v: GenericResponse) => {
          if (v.success)
          {
            let newPasswordRequest = {
              email: this.resetPasswordForm.value.username
            }

            this.service.forgotPasswordRequest(newPasswordRequest).subscribe({
              next: (v: GenericResponse) => {
                if (v.success)
                {
                  //this.bShowOTPScreen = false
                  //this.bShowLoginScreen = true
                  this.showAlertBox('You are all set!', 'Temporary password has been emailed to you. Please use that to login!')
                }
                else
                {
                  this.bLoading = false
                  this.showAlertBox('Sorry', 'Unable to reset the password for the email that you have shared. Please contact Dhabi support.')
                }
              },
              error: (e) => {
                this.bLoading = false
                this.showAlertBox('Sorry', 'Something went wrong. Please try again!')
              },
              complete :() =>
              {
                
              }
            })
          }
          else
          {
            this.bLoading = false
            this.showAlertBox('Sorry', 'Invalid OTP. Please use the correct OTP and try again!')
          }
        },
        error: (e) => {
          console.log(e)
          this.bLoading = false
        },
        complete: () => {
          
        }
      })

    }
  }

  closeAlert(state: boolean)
  {
    console.log("Closed")
    this.bAlert = false
  }

  onAlertButtonClick(event: any)
  {
    this.bAlert = event.state
  }

  alertVisibility(event: any)
  {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string)
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bAlert = true
  }

  switchLanguage(lang: string)
  {
    sessionStorage.setItem('lang',  lang)
    this.translate.use(lang)
    this.usernameField?.nativeElement.focus()

    if (lang == 'ar')
      this.renderer.setAttribute(document.body, 'dir', 'rtl');
    else
      this.renderer.setAttribute(document.body, 'dir', 'ltr');
  }
}
